import React, { useCallback, useState } from 'react';
import TableHeader from '../TableHeader';
import Pagination from '../../molecules/Pagination';
import { StyledTableLayout } from './TableLayout.styles';
import { debounce } from '../../../helpers/common';
import Button from '../Button';

function TableLayout({
  children,
  currentPage = 1,
  pageSize = 10,
  totalCount = 0,
  onChangeFilters,
  customFilterKey = '',
  exportBtn,
  createBtn,
  extraFilters,
  filters = false,
  noNegativeMargin,
  onOptionClick,
  resetFilter = false,
  tableHeading,
  noPagination,
  placeholder,
  btnType,
  btnText,
  btnImg,
  btnWidth,
  btnClass,
  btnClick,
  filterBlock,
  iconImg,
  openModal,
  content,
  setResetFilter = () => {},
  searchText,
  setSearchText,
  noStyle,
  innerHeight,
  isNextBtn,
  NextBtnClick,
  invoiceTablePagination,
  invoiPaginationPrevClick,
  invoiPaginationPrevDisabled,
  invoiPaginationNextClick,
  invoiPaginationNextDisabled,
  scrollableId,
}) {
  const [filterState, setFilterState] = useState('');

  const debouncedSetSearchQuery = useCallback(
    debounce(query => {
      setSearchText(_ => ({ ..._, searchText: query }));
    }, 300),
    [],
  );

  // Calculate showing range
  const startIndex = (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, totalCount);

  return (
    <StyledTableLayout
      noNegativeMargin={noNegativeMargin}
      noPagination={noPagination}
      filterBlock={filterBlock}
      noStyle={noStyle}
      $innerHeight={innerHeight}>
      <div className="inner-wrap" id={scrollableId}>
        <TableHeader
          total={totalCount}
          page={currentPage}
          resultPerPage={pageSize}
          setPageSize={_ => onChangeFilters({ pageSize: _, page: 1 })}
          exportBtn={exportBtn}
          createBtn={createBtn}
        />

        {children}

        {!noPagination && (
          <div className="table-footer">
            {/* Show result */}
            <div className="show-result">
              {totalCount > 0 ? (
                <>
                  Showing <span className="text">{startIndex}</span> - <span className="text">{endIndex}</span> of{' '}
                  <span>{totalCount}</span>{' '}
                </>
              ) : (
                'No results'
              )}
            </div>

            {/* Pagination */}
            <div className="pagination">
              {(totalCount > 1 || invoiceTablePagination) && (
                <Pagination
                  currentPage={currentPage}
                  totalCount={totalCount}
                  pageSize={pageSize}
                  onPageChange={page => onChangeFilters({ filter: filterState.filter, page })}
                  invoiceTablePagination={invoiceTablePagination}
                  invoiPaginationPrevClick={invoiPaginationPrevClick}
                  invoiPaginationPrevDisabled={invoiPaginationPrevDisabled}
                  invoiPaginationNextClick={invoiPaginationNextClick}
                  invoiPaginationNextDisabled={invoiPaginationNextDisabled}
                />
              )}
            </div>
            {isNextBtn && (
              <Button className="next-btn" variant="darkBlue" onClick={NextBtnClick} rounded width="150px">
                Next
              </Button>
            )}

            {/* Rows per page select */}
            {/* <div className="row-page">
              <span className="text">Rows per page:</span>
              <select value={pageSize} onChange={e => onChangeFilters({ pageSize: Number(e.target.value), page: 1 })}>
                {[5, 10, 20, 50, 100].map(size => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </div> */}
          </div>
        )}
      </div>
    </StyledTableLayout>
  );
}

export default TableLayout;
